module.exports = __webpack_public_path__ + "static/media/auth-logo.b7df7fb4.jpg";